<div class="user-initials-avatar-container container" fxLayoutAlign="center center"
     [ngStyle]="color ? {'background-color': color} : {}">
  <div class="initials">{{initials}}</div>
</div>
